import { Toast } from '@/components'

interface SelectionLimitToastProps {
  actionLabel?: string
  threshold: number
}

export const SelectionLimitToast = ({
  actionLabel = 'convert',
  threshold
}: SelectionLimitToastProps) => {
  return Toast({
    title: 'Selection Limit Reached',
    description: `You can only ${actionLabel} up to ${threshold} at a time.`,
    type: 'attention'
  })
}
